import { Injectable, Injector, isDevMode } from "@angular/core";
import { AuthService } from "@core/auth.service";
import { Observable, of, timer } from "rxjs";
import { catchError, defaultIfEmpty, retry, take, tap, timeout } from "rxjs/operators";
import { BaseService } from "../app.base.service";
import { CommonVariable } from "../app.constants";
import { SafeLocalStorageService } from "./safe-local-storage.service";

@Injectable({
  providedIn: "root",
})
export class InitFactoryService extends BaseService {
  constructor(injector: Injector, private authService: AuthService, private safeLocalStorage: SafeLocalStorageService) {
    super(injector);
  }

  load(): Observable<string> {
    const DEFAULT_LANGUAGE = this.safeLocalStorage.getItem("language_code") || "en";
    const supportedLanguages = ["en", "fr", "es", "it", "de"];

    // Skip the IP check in dev mode
    if (isDevMode()) {
      console.warn('Running in development mode, defaulting to English language.');
      this.authService.selectedlanguage$.next(DEFAULT_LANGUAGE);
      return of(DEFAULT_LANGUAGE);
    }

    // Keep well under index.html's Angular bootstrap whitescreen timeout.
    // A slow/hung ipstack must not block bootstrap (Page hiccup Oops screen).
    return this.authService.getV2CloudFunction("ipstackapiv2", { userIP: null }).pipe(
      timeout(4000),
      retry({ count: 1, delay: () => timer(500) }),
      take(1),
      tap((response) => {
        const countryCode = response?.data?.country_code?.toLowerCase?.();

        if (response?.status === "success" && typeof countryCode === "string") {
          CommonVariable.userIPstackData = response.data;

          if (supportedLanguages.includes(countryCode)) {
            this.authService.selectedlanguage$.next(countryCode);
          } else {
            this.authService.selectedlanguage$.next(DEFAULT_LANGUAGE);
          }
        } else {
          console.warn("IPStack response invalid, falling back to default language.");
          this.authService.selectedlanguage$.next(DEFAULT_LANGUAGE);
        }
      }),
      catchError((error) => {
        this.authService.selectedlanguage$.next(DEFAULT_LANGUAGE);
        return of(DEFAULT_LANGUAGE);
      }),
      defaultIfEmpty(DEFAULT_LANGUAGE)
    );
  }
}
